<template>
  <slotted-dialog
    :title="$t('servicesystem.common_objects.counter.counters')"
    :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">
    <template v-slot:content>
      <v-container v-if="counterList && counterList[0]" >
        <MachineCounterValuesTable v-for="item in counterList" :key="item.Id" :machineId="machineId" 
          :counterId="item.Id" :counterName="item.Name" v-model="item.Values">
        </MachineCounterValuesTable>
      </v-container>
      <v-container v-else>
        {{$t("servicesystem.common_objects.fallbackterms.no_counters")}}
      </v-container>
    </template>
  </slotted-dialog>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import Vue from "vue";
import MachineCounterValuesTable from "../MachineCounterValuesTable.vue";
//import MachineSelect from "@/components/MachineSelect2.vue";

export default {
  name: "MachineCounterDialog",
  props: {
    externaltrigger: Number,
    machineId: [Number, String],
  },
  components: {
    SlottedDialog,
    MachineCounterValuesTable,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      loading: false,
      counterList: [],
    };
  },

  methods: { 
    getCounters() {
      this.loading = true;
      this.getCountersWithHistoryByMachineId(this.machineId)
        .then((response) => {
            this.counterList = response;
            for (let counter of this.counterList) {
                counter.editValue = counter.Value;
            }
            this.loading = false;
        });
    },

    async setCounter(counter) {
      if (counter.Value === counter.editValue) {
        return;
      }
      else {
        counter.Value = counter.editValue;
         Vue.set(counter, 'loading', true);
        await this.setMachineCounter(counter)
          .then(() => {
            counter.errors = null;
          })
          .catch((error) => {
            if (error.status != 204) {
              console.error(error);
              counter.errors = 'Error saving value.';
            }
          })
          .finally(() => {
            Vue.set(counter, 'loading', false);
          });
      }
    },
  },

  computed: { },

  watch: {
    externaltrigger: function () {
      this.dialogtrigger++;
      this.getCounters();
    },

    machineId: function () {
      this.getCounters();
    },
  },
};
</script>